import React, { useEffect } from 'react';
import isEqual from 'lodash/isEqual';
import { dataTableStyles, HeaderRow, HeaderWrapper } from '@dealroadshow/uikit/core/components/Table/DataTable';
import TableWrapper from '@/Framework/UI/Molecules/Tables/TableWrapper';
import { FieldArray, FormSpy, useFormState } from '@/Framework/UI/Organisms/FinalForm';
import { IOptionalDataFormState } from '@/finsight/ui/components/portfolioMonitor/interfaces';
import { PORTFOLIO_OPTIONAL_DATA_FIELD_ARRAY } from './constants';
import { columns } from './columns';
import FormBottomNavigation
  from '@/finsight/ui/components/portfolioMonitor/PortfolioContent/common/FormBottomNavigation';
import { usePortfoliosContext } from '@/finsight/application/PortfolioMonitor/PortfoliosContext';
import useGetPositions from '@/finsight/ui/components/portfolioMonitor/PortfolioContent/common/useGetPositions';
import { useFormPayloadContext } from '@/finsight/application/PortfolioMonitor/FormPayloadContext';
import OptionalDataFieldsList from './OptionalDataFieldsList';
import ConfirmDeletePositionContextProvider
  from '@/finsight/ui/components/portfolioMonitor/PortfolioContent/common/ConfirmDeletePositionContext/ConfirmDeletePositionContext';
import ConfirmDeletePositionModal
  from '@/finsight/ui/components/portfolioMonitor/PortfolioContent/common/ConfirmDeletePositionContext/ConfirmDeletePositionModal';

import spaceStyles from '@dealroadshow/uikit/core/styles/helpers/spaces.scss';

interface IProps {
  setIsAnyChanges: React.Dispatch<React.SetStateAction<boolean>>,
  cancelButtonClick: () => void,
}

const OptionalDataFields = ({ setIsAnyChanges, cancelButtonClick }: IProps) => {
  const {
    hasValidationErrors,
    hasSubmitErrors,
    dirtySinceLastSubmit,
    active,
    dirty,
    values,
  } = useFormState<IOptionalDataFormState>();
  const { isLoading } = usePortfoliosContext();
  const { listIndex } = useGetPositions();
  const { setPayload } = useFormPayloadContext();

  useEffect(() => {
    if (dirty && !active) {
      setPayload((prevState) => {
        prevState.lists[listIndex].positions = values[PORTFOLIO_OPTIONAL_DATA_FIELD_ARRAY];

        return prevState;
      });
    }
  }, [active, dirty, values]);

  return (
    <>
      <FormSpy
        onChange={
        ({ dirty, values, initialValues }) => setIsAnyChanges(
            (prev) => prev || (dirty && !isEqual(initialValues, values)),
        )
      }
      />
      <TableWrapper className={ spaceStyles.pn }>
        <table className={ dataTableStyles.dataTable }>
          <HeaderWrapper>
            <HeaderRow columns={ columns } />
          </HeaderWrapper>
        </table>
        <FieldArray
          name={ PORTFOLIO_OPTIONAL_DATA_FIELD_ARRAY }
          render={ ({ fields }) => (
            <ConfirmDeletePositionContextProvider fields={ fields }>
              <>
                <ConfirmDeletePositionModal />
                <OptionalDataFieldsList />
              </>
            </ConfirmDeletePositionContextProvider>
          ) }
        />
        <FormBottomNavigation
          isLoading={ isLoading }
          isSubmitDisabled={ isLoading || hasValidationErrors || (hasSubmitErrors && !dirtySinceLastSubmit) }
          onCancelClick={ cancelButtonClick }
          submitButtonTitle="Complete"
        />
      </TableWrapper>
    </>
  );
};

export default OptionalDataFields;
